import {
  Actor,
  Engine,
  vec,
  Vector,
  // PointerEvent,
  // GpuParticleEmitter,
  CollisionType,
} from 'excalibur';
import { EventsManager, Unsubscribe } from '@game-libs/events-manager';
import { GameplayEvents } from '../types/game-events';
import { ShockWavePostProcessor } from '@game-libs/exc-libs/src/shaders';
import { HitEffect } from './hitEffect';
// import { showerParticle } from '@game-libs/exc-libs';
import { arrivalSmokeAnimation, bigDragonAnimation } from './animations';
import { DeathExplosion } from './deathExplosion';
import { Images } from './resources';
import { TutorialLevel } from './tutorialLevel';
import { DamageSource } from '../types/game-types';

export class BigDragon extends Actor {
  subscriptions: Unsubscribe[] = [];
  dragon = new Actor({
    collisionType: CollisionType.PreventCollision,
  });

  private engine?: Engine;
  private shockwave?: ShockWavePostProcessor;
  // Pending roar shockwave timers — cleared on cleanup so removed dragons don't keep firing.
  private roarTimeouts: ReturnType<typeof setTimeout>[] = [];

  constructor() {
    super({
      collisionType: CollisionType.PreventCollision,
    });

    this.scale = vec(2.1, 2.1);

    this.z = this.pos.y;
  }

  onAdd(engine: Engine): void {
    const { on } = EventsManager();

    this.dragon.pos.y += 80;



    this.subscriptions.push(
      on(GameplayEvents.DAMAGE_DRAGON, ({ isCritical: isCriticalHit, source }) => {
        if (source === DamageSource.Click) {
          const hitPosition = (this.scene as TutorialLevel).getDragonPosition(vec(0, -120));
          const hitEffect = new HitEffect(hitPosition, isCriticalHit);
          this.scene?.add(hitEffect);
        }
      }),
    );

    // this.dragon.on('pointerdown', (evt: PointerEvent) => {
    //   emit(GameplayEvents.CLICK_GAME_DRAGON);
    // });

    // this.dragon.on('pointerenter', (evt: PointerEvent) => {
    //   emit(GameplayEvents.CLICK_GAME_DRAGON);
    // });

    // this.dragon.on('pointerup', (evt: PointerEvent) => {
    //   emit(GameplayEvents.STOP_CLICK_GAME_DRAGON);
    // });

    // this.dragon.on('pointerleave', (evt: PointerEvent) => {
    //   emit(GameplayEvents.STOP_CLICK_GAME_DRAGON);
    // });

    this.engine = engine;
    this.shockwave = new ShockWavePostProcessor();
    this.shockwave.init(engine.currentScene);
    engine.graphicsContext.addPostProcessor(this.shockwave);

    const shadow = new Actor({
      width: 140,
      height: 140,
      collisionType: CollisionType.PreventCollision,
    });
    shadow.scale = vec(0.8, 0.8);
    shadow.graphics.use(Images.UnderShadow.toSprite());
    this.addChild(shadow);
    shadow.pos.y -= 6;
    shadow.z = this.pos.y - 10;

    this.dragon.scale = vec(1, 1);
    this.dragon.graphics.use(bigDragonAnimation.idle);

    this.dragon.anchor.setTo(0.5, 1);
    this.addChild(this.dragon);
    this.dragon.z = this.pos.y;

    const smokeEffect = new Actor({
      pos: vec(0, -120),
      anchor: vec(0.5, 0.3),
      collisionType: CollisionType.PreventCollision,
    });
    smokeEffect.scale = vec(3, 3);
    smokeEffect.graphics.use(arrivalSmokeAnimation.clone());
    this.addChild(smokeEffect);
    smokeEffect.z = this.dragon.z


    this.subscriptions.push(
      on(GameplayEvents.DRAGON_ROAR, () => {
        this.dragon.graphics.use(bigDragonAnimation.roar);
        this.roar(vec(this.pos.x / engine.canvasWidth, (this.pos.y - 100) / engine.canvasHeight));
      }),
    );
  }

  public startDeathSequence() {
    this.dragon.graphics.use(bigDragonAnimation.dying);
    this.actions.fade(0, 3000).die();

    const deathExplosion = new DeathExplosion(this.pos.add(vec(0, -100)));
    this.scene?.add(deathExplosion);
  }

  roar(position: Vector) {
    this.clearRoarTimeouts();

    const shockwave = this.shockwave;
    if (!shockwave) {
      return;
    }

    this.roarTimeouts.push(
      setTimeout(() => {
        shockwave.triggerShockWave(position, 800, 10, 0.6, 0.08);
      }, 100),
      setTimeout(() => {
        shockwave.triggerShockWave(position, 800, 11, 0.8, 0.06);
      }, 400),
      setTimeout(() => {
        shockwave.triggerShockWave(position, 800, 12, 0.9, 0.04);
      }, 600),
      setTimeout(() => {
        shockwave.triggerShockWave(position, 800, 13, 1, 0.02);
      }, 800),
    );
  }

  private clearRoarTimeouts() {
    for (const timeoutId of this.roarTimeouts) {
      clearTimeout(timeoutId);
    }
    this.roarTimeouts = [];
  }

  onRemove() {
    this.cleanup();
  }

  cleanup() {
    this.subscriptions.forEach((unsubscribe) => unsubscribe());
    this.subscriptions = [];

    this.clearRoarTimeouts();

    if (this.shockwave && this.engine) {
      this.shockwave.dispose();
      this.engine.graphicsContext.removePostProcessor(this.shockwave);
    }
    this.shockwave = undefined;
    this.engine = undefined;
  }
}
